import * as React from "react";
import { useCountryValue } from "../Contexts/CountryContext";
import * as Action from "../Types/ReducerTypes";
import { sendGtmEvent, GoogleEvent } from "../GoogleTagManager";
function DeviceSelector() {
  var _a = useCountryValue(),
    state = _a[0],
    dispatch = _a[1];
  if (state.country !== "de") {
    return null;
  }
  function phone(evt) {
    evt.preventDefault();
    dispatch({
      type: Action.COUNTRY_CHANGE_DEVICE,
      device: "phone"
    });
    sendGtmEvent(GoogleEvent.HEADER_DEVICE_SELECTION, "phone");
  }
  function mobile(evt) {
    evt.preventDefault();
    dispatch({
      type: Action.COUNTRY_CHANGE_DEVICE,
      device: "mobile"
    });
    sendGtmEvent(GoogleEvent.HEADER_DEVICE_SELECTION, "mobile");
  }
  return /*#__PURE__*/React.createElement("div", {
    className: 'deviceSelector c-device-selector'
  }, /*#__PURE__*/React.createElement("button", {
    onClick: phone,
    className: "choose choleft c-device-selector__button " + (state.device === "phone" ? "active c-device-selector__button--active" : "")
  }, "Direkt"), /*#__PURE__*/React.createElement("button", {
    onClick: mobile,
    className: "choose choright c-device-selector__button " + (state.device === "mobile" ? "active c-device-selector__button--active" : "")
  }, "Vermittlung"));
}
export default DeviceSelector;